import imageCompression from 'browser-image-compression';
import heic2any from 'heic2any';
import { useEffect, useState } from "react";
import { AiFillCloseCircle, AiFillStar, AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import { BsImage } from "react-icons/bs";
import { Bars } from "react-loader-spinner";
import { toast } from "react-toastify";
import { fragranceSizes } from "../../helpers/data";
import determineFileType from "../../helpers/fileType";
import { useCategoriesQuery } from "../../service/categoryApi";
import {
  useDeleteProductMutation,
  useGetProductByIdQuery,
  useProductsQuery,
  useUpdateProductMutation,
} from "../../service/productApi";
import DeleteModal from "../Common/DeleteModal/DeleteModal";
import { uploadImage } from "../../helpers/uploadImage";

const ProductList = () => {
  const { data: categoriesData } = useCategoriesQuery();
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const { data, isLoading } = useProductsQuery({ 
    cat: "all", 
    page: page, 
    limit: 8, 
    search: debouncedSearchTerm 
  });
  const [deleteProduct] = useDeleteProductMutation();
  const [updateProduct] = useUpdateProductMutation();
  const [selected, setSelected] = useState("");

  // Category and subcategory state
  const [category, setCategory] = useState("select category");
  const [subCategory, setSubCategory] = useState("select sub-category");
  const [selectedCat, setSelectedCat] = useState({});
  const [shipping, setShipping] = useState("select shipping");
  
  const shippingData = [
    {
      name: "Small box up to 2kg £3.99",
      value: 3.99,
    },
    {
      name: "Medium box up to 10kg £6.80",
      value: 6.80,
    },
    {
      name: "Large box up to 20kg £11",
      value: 11,
    },
    {
      name: "Large letter up to 1kg £2.70",
      value: 2.70,
    },
      {
      name: "Evri Parcel - £2.94",
      value: 2.94,
    },
  ];

  // Debouncing search term
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
      setPage(1); // Reset to first page when searching
    }, 500); // 500ms delay

    return () => clearTimeout(timer);
  }, [searchTerm]);

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const { data: product } = useGetProductByIdQuery(selected?._id);
  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState("");
  const [cquantity, setCquantity] = useState([]);
  const [sCheck, setSCheck] = useState(false);
  const [sQuantity, setSQuantity] = useState(0);
  const [mCheck, setMCheck] = useState(false);
  const [mQuantity, setMQuantity] = useState(0);
  const [lCheck, setLCheck] = useState(false);
  const [lQuantity, setLQuantity] = useState(0);
  const [xlCheck, setXlCheck] = useState(false);
  const [xlQuantity, setXlQuantity] = useState(0);
  const [twoXlCheck, setTwoXlCheck] = useState(false);
  const [twoXlQuantity, setTwoXlQuantity] = useState(0);
  const [description, setDescription] = useState("");
  const [name, setName] = useState("");
  const [brand, setBrand] = useState("");
  const [sizeML, setSizeML] = useState("select size");

  useEffect(() => {
    if (
      selected?.category === "fashion" &&
      selected?.subCategory === "clothes"
    ) {
      setPrice(selected?.price);
      setDescription(selected?.description);
      setName(selected?.name);
      setBrand(selected?.brand || "");
      setCategory(selected?.category || "select category");
      setSubCategory(selected?.subCategory || "select sub-category");
      if (selected?.cquantity?.length > 0) {
        setSCheck(selected?.cquantity[0]?.quantity > 0 ? true : false);
        setSQuantity(selected?.cquantity[0]?.quantity);
        setMCheck(selected?.cquantity[1]?.quantity > 0 ? true : false);
        setMQuantity(selected?.cquantity[1]?.quantity);
        setLCheck(selected?.cquantity[2]?.quantity > 0 ? true : false);
        setLQuantity(selected?.cquantity[2]?.quantity);
        setXlCheck(selected?.cquantity[3]?.quantity > 0 ? true : false);
        setXlQuantity(selected?.cquantity[3]?.quantity);
        setTwoXlCheck(selected?.cquantity[4]?.quantity > 0 ? true : false);
        setTwoXlQuantity(selected?.cquantity[4]?.quantity);
      }
    } else {
      setPrice(selected?.price);
      setQuantity(selected?.quantity);
      setDescription(selected?.description);
      setName(selected?.name);
      setBrand(selected?.brand || "");
      setCategory(selected?.category || "select category");
      setSubCategory(selected?.subCategory || "select sub-category");
      setShipping(selected?.shipping || "select shipping");
      if (selected?.category === "fragrances" && selected?.sizeML) {
        setSizeML(selected?.sizeML);
      }
    }
    
    // Set selected category for subcategory dropdown
    if (selected?.category) {
      const selectedCategory = categoriesData?.data?.find(
        (value) => value.value === selected.category
      );
      setSelectedCat(selectedCategory || {});
    }
  }, [
    cquantity.length,
    selected?.category,
    selected?.cquantity,
    selected?.description,
    selected?.name,
    selected?.price,
    selected?.quantity,
    selected?.sizeML,
    selected?.subCategory,
    categoriesData?.data,
  ]);
  const handleDeleteProduct = () => {
    if (selected?._id) {
      deleteProduct(selected?._id).then((res) => {
        if (res?.data?.status) {
          toast.success(res?.data?.message);
          setDeleteModal(false);
          setSelected({});
        } else {
          toast.error(res?.data?.message);
        }
      });
    } else {
      toast.error("Please Select at least one element!");
    }
  };

  const handleUpdateProduct = () => {
    let data = {};
    if (category === "fragrances" && sizeML !== "select size") {
      data = {
        description: description,
        price: parseFloat(price),
        quantity: parseFloat(quantity),
        name: name,
        brand: brand,
        category: category,
        subCategory: subCategory,
        shipping: shipping,
        cquantity: [
          { name: "s", quantity: parseInt(sQuantity) },
          { name: "m", quantity: parseInt(mQuantity) },
          { name: "l", quantity: parseInt(lQuantity) },
          { name: "xl", quantity: parseInt(xlQuantity) },
          { name: "2xl", quantity: parseInt(twoXlQuantity) },
        ],
        images: images,
        sizeML: sizeML,
      };
    } else {
      data = {
        description: description,
        price: parseFloat(price),
        quantity: parseFloat(quantity),
        name: name,
        brand: brand,
        category: category,
        subCategory: subCategory,
        shipping: shipping,
        cquantity: [
          { name: "s", quantity: parseInt(sQuantity) },
          { name: "m", quantity: parseInt(mQuantity) },
          { name: "l", quantity: parseInt(lQuantity) },
          { name: "xl", quantity: parseInt(xlQuantity) },
          { name: "2xl", quantity: parseInt(twoXlQuantity) },
        ],
        images: images,
      };
    }
    updateProduct({ id: selected?._id, data: data }).then((res) => {
      if (res?.data?.status) {
        toast.success(res?.data?.message);
        setDeleteModal(false);
        setSelected({});
        setUpdateModal(false);
        setSCheck(false);
        setXlCheck(false);
        setMCheck(false);
        setLCheck(false);
        setTwoXlCheck(false);
        setSQuantity(0);
        setMQuantity(0);
        setLQuantity(0);
        setXlQuantity(0);
        setTwoXlQuantity(0);
        setCategory("select category");
        setSubCategory("select sub-category");
        setSelectedCat({});
        setShipping("select shipping");
        setBrand("");
      } else {
        toast.error(res?.data?.message);
      }
    });
  };

  const handleImageUpload = async (e) => {
    setLoading(true);

    if (!e.target.files || e.target.files.length === 0) {
      setLoading(false);
      return;
    }

    // Process each file
    for (let i = 0; i < e.target.files.length; i++) {
      try {
        let file = e.target.files[i];
        let fileName = file.name;

        // Cloud Run rejects requests over 32MB before they reach the server.
        const MAX_UPLOAD_BYTES = 31 * 1024 * 1024;

        // Videos can't go through image compression — upload them as-is.
        if (file.type.startsWith('video/')) {
          if (file.size > MAX_UPLOAD_BYTES) {
            toast.error(`${fileName} is too large (max 31MB). Skipping...`);
            continue;
          }
          const url = await uploadImage(file);
          setImages((prevImages) => [...prevImages, url]);
          continue;
        }

        // Check if file is HEIC
        if (file.type === 'image/heic' || file.name.toLowerCase().endsWith('.heic')) {
          try {
            // Convert HEIC to PNG
            const convertedBlob = await heic2any({
              blob: file,
              toType: 'image/png',
              quality: 0.8
            });
            // Create a new file from the converted blob
            file = new File([convertedBlob], fileName.replace(/\.heic$/i, '.png'), {
              type: 'image/png'
            });
            fileName = file.name;
          } catch (error) {
            console.error('Error converting HEIC:', error);
            toast.error('Failed to convert HEIC image. Skipping...');
            continue;
          }
        }

        // Compress the image (no resizing, just quality)
        try {
          file = await imageCompression(file, {
            maxSizeMB: 8,
            maxWidthOrHeight: 2560,
            initialQuality: 0.7,
            useWebWorker: true
          });
        } catch (compressionError) {
          console.error('Error compressing image:', compressionError);
          toast.error('Failed to compress image. Skipping...');
          continue;
        }

        // Upload via our API, which stores the file in Google Cloud Storage.
        const url = await uploadImage(file);
        setImages((prevImages) => [...prevImages, url]);
      } catch (error) {
        console.error('Error uploading file:', error);
        toast.error(`Failed to upload ${e.target.files[i].name}: ${error.message}`);
      }
    }

    setLoading(false);
  };
  const handleRemove = (img) => {
    const filter = images.filter((i) => i !== img);
    setImages(filter);
  };

  // Reorder images. The first image is the product's cover/banner on the store.
  const moveImage = (index, dir) => {
    const to = index + dir;
    if (to < 0 || to >= images.length) return;
    const next = [...images];
    [next[index], next[to]] = [next[to], next[index]];
    setImages(next);
  };
  const setAsCover = (index) => {
    if (index <= 0) return;
    const next = [...images];
    const [img] = next.splice(index, 1);
    next.unshift(img);
    setImages(next);
  };

  const handleCategory = (e) => {
    setCategory(e.target.value);
    const selected = categoriesData?.data?.find(
      (value) => value.value === e.target.value
    );
    setSelectedCat(selected);
    setSubCategory("select sub-category"); // Reset subcategory when category changes
  };

  return (
    <div>
      <div className="bg-gray-700 my-[30px] rounded p-[10px]">
        <h3 className="text-start text-[20px] font-bold text-white mb-[20px]">
          Product List
        </h3>
        {/* search products */}
        <div className="flex justify-end items-center mb-[20px] gap-2">
          <div className="relative flex-1">
            <input
              type="text"
              placeholder="Search products by name, brand, description, or category..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="bg-gray-900 outline-none font-[17px] text-white p-[10px] w-[100%] rounded pr-10"
            />
            {searchTerm && (
              <button
                onClick={() => setSearchTerm("")}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-white"
              >
                ✕
              </button>
            )}
          </div>
        </div>
        {debouncedSearchTerm && (
          <div className="text-white mb-4">
            {isLoading ? (
              <span>Searching...</span>
            ) : (
              <span>
                Search results for "{debouncedSearchTerm}": {data?.pagination?.totalItems || 0} products found
              </span>
            )}
          </div>
        )}
        <div class="relative overflow-x-auto shadow-md bg-gray-900 sm:rounded-lg lg:min-h-[570px]">
          <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead>
              <tr className="shadow shadow-gray-700">
                <th scope="col" class="px-6 py-3">
                  Name
                </th>
                <th scope="col" class="px-6 py-3">
                  Brand
                </th>
                <th scope="col" class="px-6 py-3">
                  Quantity
                </th>
                <th scope="col" class="px-6 py-3">
                  Price
                </th>
                <th scope="col" class="px-6 py-3">
                  Category
                </th>
                <th scope="col" class="px-6 py-3">
                  Update
                </th>
                <th scope="col" class="px-6 py-3">
                  Delete
                </th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="7" className="px-6 py-4 text-center text-white">
                    Loading products...
                  </td>
                </tr>
              ) : data?.data?.length === 0 ? (
                <tr>
                  <td colSpan="7" className="px-6 py-4 text-center text-white">
                    {debouncedSearchTerm ? "No products found matching your search." : "No products available."}
                  </td>
                </tr>
              ) : (
                                data?.data?.map((d) => (
                  <tr key={d._id} className="shadow shadow-gray-700">
                    <td class="px-6 py-4">{d?.name}</td>
                    <td class="px-6 py-4">{d?.brand}</td>
                    <td class="px-6 py-4">
                      {d?.category === "fashion" &&
                      d?.subCategory === "clothes" ? (
                        <>
                          <p className="text-gray-500">
                            {d?.cquantity?.map((q) => (
                              <>
                                {q?.quantity > 0 && (
                                  <span className="uppercase">
                                    {q?.name}={q?.quantity},{" "}
                                  </span>
                                )}
                              </>
                            ))}
                          </p>
                        </>
                      ) : (
                        <p className="text-gray-500">
                          {d?.quantity ? d?.quantity : "Not Available"}
                          {d?.category === "fragrances" &&
                            d?.sizeML &&
                            `/${d?.sizeML}`}
                        </p>
                      )}
                    </td>
                    <td class="px-6 py-4">${parseFloat(d?.price).toFixed(2)}</td>
                    <td class="px-6 py-4">{d?.category}</td>

                    <td class="px-6 py-4">
                      <button
                        onClick={() => {
                          setUpdateModal(true);
                          setSelected(d);
                          setImages(d?.images);
                        }}
                        className="bg-[#47db47] px-[20px] py-[7px] rounded text-[white] hover:bg-[#399439] active:bg-[#9b3232]"
                      >
                        Update
                      </button>
                    </td>
                    <td class="px-6 py-4">
                      <button
                        onClick={() => {
                          setSelected(d);
                          setDeleteModal(true);
                        }}
                        className="bg-[#ce3737] px-[20px] py-[7px] rounded text-[white] hover:bg-[#ff3939] active:bg-[#9b3232]"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <div className="flex flex-wrap justify-between items-center gap-3 mt-[15px]">
          <div className="text-[#fff] font-bold">
            Page {page} of {data?.pagination?.totalPages} Pages
          </div>
          <div className="text-[#fff] font-bold">
            Total {data?.pagination?.totalItems} Items
          </div>
          <div>
            {page > 1 ? (
              <button
                onClick={() => setPage(page - 1)}
                className="text-[#fff] border-[1px] border-[#fff] px-[20px] py-[8px] w-[100px] rounded font-bold mr-[10px] hover:bg-white hover:text-[black]"
              >
                Previous
              </button>
            ) : (
              <button
                disabled
                className="text-[grey] border-[1px] border-[grey] px-[20px] py-[8px] w-[100px] rounded font-bold mr-[10px] "
              >
                Previous
              </button>
            )}
            {page < data?.pagination?.totalPages ? (
              <button
                onClick={() => setPage(page + 1)}
                className="text-[#fff] border-[1px] border-[#fff] px-[20px] py-[8px] w-[100px] rounded font-bold ml-[10px] hover:bg-white hover:text-[black]"
              >
                Next
              </button>
            ) : (
              <button
                disabled
                className="text-[grey] border-[1px] border-[grey] px-[20px] py-[8px] w-[100px] rounded font-bold ml-[10px]"
              >
                Next
              </button>
            )}
          </div>
        </div>
      </div>
      {updateModal && (
        <div class="fixed top-0 left-0 right-0 bottom-0 z-50 pt-[200px] w-full flex justify-center p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
          <div class="relative w-full max-w-md max-h-full">
            <div class="relative rounded-lg shadow bg-gray-600">
              <button
                onClick={() => {
                  setUpdateModal(false);
                  setCategory("select category");
                  setSubCategory("select sub-category");
                  setSelectedCat({});
                  setShipping("select shipping");
                  setBrand("");
                }}
                type="button"
                class="absolute top-3 right-2.5 text-gray-300 bg-transparent rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center hover:text-white"
                data-modal-hide="authentication-modal"
              >
                <svg
                  class="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span class="sr-only">Close modal</span>
              </button>
              <div class="px-6 py-6 lg:px-8">
                <h3 className="text-center text-[20px] font-bold text-white mb-[20px]">
                  Update Product
                </h3>

                <div className="mb-3 flex flex-col">
                  <div className="mb-[12px]">
                    <label className="text-white mb-[10px]">Name</label>
                    <input
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className="bg-gray-900 outline-none font-[17px] text-white p-[10px] w-[100%] rounded"
                    />
                  </div>
                  <div className="mb-[12px]">
                    <label className="text-white mb-[10px]">Brand</label>
                    <input
                      value={brand}
                      onChange={(e) => setBrand(e.target.value)}
                      className="bg-gray-900 outline-none font-[17px] text-white p-[10px] w-[100%] rounded"
                    />
                  </div>
                  <div className="mb-3 flex flex-col">
                    <label className="text-white mb-[10px]">Description</label>
                    <textarea
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded focus:border-0 h-[200px]"
                      cols={12}
                    />
                  </div>{" "}
                  <div className="mb-[12px]">
                    <label className="text-white mb-[10px]">Price</label>
                    <input
                      value={price}
                      onChange={(e) => setPrice(e.target.value)}
                      className="bg-gray-900 outline-none font-[17px] text-white p-[10px] w-[100%] rounded"
                    />
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-3">
                    <div className="mb-3 flex flex-col">
                      <label className="text-white mb-[10px]">Category</label>
                      <select
                        value={category}
                        onChange={handleCategory}
                        className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded border-0 focus:outline-none focus:border-0"
                      >
                        <option value={"select category"}>Select Category</option>
                        {categoriesData?.data?.map((d) => (
                          <option key={d?._id} value={d?.value}>
                            {d?.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3 flex flex-col">
                      <label className="text-white mb-[10px]">Sub Category</label>
                      <select
                        value={subCategory}
                        onChange={(e) => setSubCategory(e.target.value)}
                        disabled={selectedCat?._id ? false : true}
                        className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded border-0 focus:outline-none focus:border-0"
                      >
                        <option value={"select sub-category"}>Select Sub-Category</option>
                        {selectedCat?.subCategories?.map((d) => (
                          <option key={d} value={d}>
                            {d}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 flex flex-col">
                    <label className="text-white mb-[10px]">Shipping</label>
                    <select
                      value={shipping}
                      onChange={(e) => setShipping(e.target.value)}
                      className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded border-0 focus:outline-none focus:border-0"
                    >
                      <option value={"select shipping"}>Select Shipping</option>
                      {shippingData?.map((d) => (
                        <option key={d?.name} value={d?.value}>
                          {d?.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  {category === "fashion" &&
                  subCategory === "clothes" ? (
                    <>
                      <div className="mb-3 flex flex-col">
                        <label className="text-white mb-[10px]">
                          Size and Quantity
                        </label>
                        <div className="mb-3">
                          <div className=" flex justify-start items-center">
                            <div className="flex justify-start items-center w-[200px]">
                              <input
                                type="checkbox"
                                checked={sCheck}
                                onChange={(e) => setSCheck(e.target.checked)}
                                className="focus:outline-none focus:border-0 h-[20px] w-[20px]"
                                id="sCheck"
                              />
                              <label
                                for="sCheck"
                                className="text-white text-[16px] font-semibold ml-[12px]"
                              >
                                Small(S)
                              </label>
                            </div>

                            {sCheck && (
                              <input
                                type="number"
                                value={sQuantity}
                                placeholder="Quantity(S)"
                                onChange={(e) => setSQuantity(e.target.value)}
                                className="bg-gray-900 outline-none text-[14px] text-white p-[10px] ml-[15px] rounded"
                              />
                            )}
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className=" flex justify-start items-center">
                            <div className="flex justify-start items-center w-[200px]">
                              <input
                                type="checkbox"
                                checked={mCheck}
                                onChange={(e) => setMCheck(e.target.checked)}
                                id="mCheck"
                                className="focus:outline-none focus:border-0 h-[20px] w-[20px]"
                              />
                              <label
                                for="mCheck"
                                className="text-white text-[16px] font-semibold ml-[12px]"
                              >
                                Medium(M)
                              </label>
                            </div>

                            {mCheck && (
                              <input
                                type="number"
                                value={mQuantity}
                                placeholder="Quantity(M)"
                                onChange={(e) => setMQuantity(e.target.value)}
                                className="bg-gray-900 outline-none text-[14px] text-white p-[10px] ml-[15px] rounded"
                              />
                            )}
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className=" flex justify-start items-center">
                            <div className="flex justify-start items-center w-[200px]">
                              <input
                                type="checkbox"
                                checked={lCheck}
                                id="lCheck"
                                onChange={(e) => setLCheck(e.target.checked)}
                                className="focus:outline-none focus:border-0 h-[20px] w-[20px]"
                              />
                              <label
                                for="lCheck"
                                className="text-white text-[16px] font-semibold ml-[12px]"
                              >
                                Large(L)
                              </label>
                            </div>
                            {lCheck && (
                              <input
                                type="number"
                                value={lQuantity}
                                placeholder="Quantity(L)"
                                onChange={(e) => setLQuantity(e.target.value)}
                                className="bg-gray-900 outline-none text-[14px] text-white p-[10px] ml-[15px] rounded"
                              />
                            )}
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className=" flex justify-start items-center">
                            <div className="flex justify-start items-center w-[200px]">
                              <input
                                type="checkbox"
                                checked={xlCheck}
                                onChange={(e) => setXlCheck(e.target.checked)}
                                id="xlCheck"
                                className="focus:outline-none focus:border-0 h-[20px] w-[20px]"
                              />
                              <label
                                for="xlCheck"
                                className="text-white text-[16px] font-semibold ml-[12px]"
                              >
                                Extra-Large(XL)
                              </label>
                            </div>

                            {xlCheck && (
                              <input
                                type="number"
                                value={xlQuantity}
                                placeholder="Quantity(XL)"
                                onChange={(e) => setXlQuantity(e.target.value)}
                                className="bg-gray-900 outline-none text-[14px] text-white p-[10px] ml-[15px] rounded"
                              />
                            )}
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className=" flex justify-start items-center">
                            <div className="flex justify-start items-center w-[200px]">
                              <input
                                type="checkbox"
                                checked={twoXlCheck}
                                onChange={(e) =>
                                  setTwoXlCheck(e.target.checked)
                                }
                                id="twoXlCheck"
                                className="focus:outline-none focus:border-0 h-[20px] w-[20px]"
                              />
                              <label
                                for="twoXlCheck"
                                className="text-white text-[16px] font-semibold ml-[12px]"
                              >
                                Extra-Extra-Large(2XL)
                              </label>
                            </div>

                            {twoXlCheck && (
                              <input
                                type="number"
                                value={twoXlQuantity}
                                placeholder="Quantity(2XL)"
                                onChange={(e) =>
                                  setTwoXlQuantity(e.target.value)
                                }
                                className="bg-gray-900 outline-none text-[14px] text-white p-[10px] ml-[15px] rounded"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div>
                        <label className="text-white mb-[10px]">Quantity</label>
                        <input
                          value={quantity}
                          onChange={(e) => setQuantity(e.target.value)}
                          className="bg-gray-900 outline-none font-[17px] text-white p-[10px] w-[100%] rounded"
                        />
                      </div>
                    </>
                  )}
                  {category === "fragrances" && (
                    <div className="mb-3 flex flex-col">
                      <label id="sizeML" className="text-white mb-[10px]">
                        Fragrance Size(ML)
                      </label>
                      {/* <input
                        value={sizeML}
                        onChange={(e) => setSizeML(e.target.value)}
                        className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded"
                      /> */}
                      <select
                        id="sizeML"
                        value={sizeML}
                        onChange={(e) => setSizeML(e.target.value)}
                        className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded border-0 focus:outline-none focus:border-0"
                      >
                        <option value={"select size"}>Select Size</option>
                        {fragranceSizes?.map((d) => (
                          <option key={d?.value} value={d?.value}>
                            {d?.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  <div className="grid gap-4 mb-3">
                    <div className="mb-3 flex flex-col">
                      <label className="text-white mb-[10px]">
                        Product Images
                      </label>
                      <div>
                        <label
                          className="text-[1.5rem] flex items-center gap-[.5rem] justify-center w-[100%] h-[100px] bg-gray-900 cursor-pointer text-white"
                          htmlFor="update-banner"
                        >
                          {loading ? (
                            <Bars
                              height="80"
                              width="80"
                              color="#fff"
                              ariaLabel="bars-loading"
                              wrapperStyle={{}}
                              wrapperClass=""
                              visible={true}
                            />
                          ) : (
                            <>
                              <BsImage /> Upload Image
                              <input
                                onChange={handleImageUpload}
                                className="hidden"
                                type="file"
                                name="update-banner"
                                id="update-banner"
                                multiple
                                accept="image/*,.heic"
                              />
                            </>
                          )}
                        </label>
                      </div>
                      {images.length > 0 && (
                        <>
                          <p className="text-white font-semibold text-[13px] mt-[15px]">
                            Uploaded Images
                          </p>
                          <p className="text-gray-400 text-[12px] mb-[8px]">
                            The first image is the product cover/banner. Use the
                            arrows to reorder or ★ to set an image as the cover.
                          </p>
                          <div className="flex flex-wrap justify-start items-center gap-[10px]">
                            {images?.map((image, idx) => (
                              <div key={image} className="relative">
                                {idx === 0 && (
                                  <span className="absolute top-[10px] left-[10px] z-10 rounded bg-blue-600 px-2 py-0.5 text-[11px] font-semibold text-white">
                                    Cover
                                  </span>
                                )}
                                {determineFileType(image) === "video" ? (
                                  <video
                                    className="h-[200px] w-[200px] bg-slate-500 object-cover"
                                    src={image}
                                    alt="images"
                                    controls
                                    autoPlay={false}
                                  />
                                ) : (
                                  <img
                                    className="h-[200px] w-[200px] object-cover"
                                    src={image}
                                    alt="images"
                                  />
                                )}
                                <AiFillCloseCircle
                                  style={{ color: "white" }}
                                  className="h-[28px] w-[28px] absolute top-[10px] right-[10px] cursor-pointer"
                                  onClick={() => handleRemove(image)}
                                />
                                <div className="absolute bottom-0 left-0 right-0 flex items-center justify-between bg-black/60 px-2 py-1 text-white">
                                  <button
                                    type="button"
                                    title="Move left"
                                    onClick={() => moveImage(idx, -1)}
                                    disabled={idx === 0}
                                    className="p-1 disabled:opacity-30"
                                  >
                                    <AiOutlineLeft />
                                  </button>
                                  <button
                                    type="button"
                                    title="Set as cover / banner"
                                    onClick={() => setAsCover(idx)}
                                    disabled={idx === 0}
                                    className="flex items-center gap-1 text-[11px] disabled:opacity-30"
                                  >
                                    <AiFillStar /> Cover
                                  </button>
                                  <button
                                    type="button"
                                    title="Move right"
                                    onClick={() => moveImage(idx, 1)}
                                    disabled={idx === images.length - 1}
                                    className="p-1 disabled:opacity-30"
                                  >
                                    <AiOutlineRight />
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <button
                  onClick={handleUpdateProduct}
                  className="bg-[#47db47] w-[100%] px-[20px] py-[7px] rounded text-[white] hover:bg-[#399439] active:bg-[#9b3232]"
                >
                  Update Product
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {deleteModal && (
        <DeleteModal
          handleDelete={handleDeleteProduct}
          closeModal={setDeleteModal}
        />
      )}
    </div>
  );
};

export default ProductList;
